import { Grid } from '@material-ui/core';
import dxLogo from 'assets/dx_white.png';
import TotalLogo from 'components/TotalLogo';
import { PATHS } from 'constants/paths';
import { getUnifiedWellName } from 'helpers/WellHelper';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { useSelectCurrentWell } from 'redux/Wells/selectors';

import styles from './HeaderMobile.module.scss';

type Props = {
  withMobileWellSelect?: boolean;
};

const HeaderMobile = ({ withMobileWellSelect = true }: Props) => {
  const well = useSelectCurrentWell();
  const intl = useIntl();

  return (
    <Grid container component="header" className={styles.headerContainer}>
      <Link to={PATHS.HOME} className={styles.logoLink}>
        <TotalLogo className={styles.totalLogo} />
        <img className={styles.drillxLogo} alt="DrillX logo" src={dxLogo} />
      </Link>
      {withMobileWellSelect && (
        <div className={styles.wellNameHeader}>
          <span className={styles.headerTextWellName}>
            {withMobileWellSelect && well ? getUnifiedWellName(well) : ''}
          </span>
          <span className={styles.headerTextEddr}>
            {withMobileWellSelect && intl.formatMessage({ id: 'header.pages.EDDR' }).toUpperCase()}
          </span>
        </div>
      )}
    </Grid>
  );
};

export default HeaderMobile;
